import { axiosInstance } from '@/utils/axiosInstance';

export interface IStoreConfigResponse {
  url: string;
}

export const StoreConfigService = {
  getStoreConfig: async (): Promise<string> => {
    const res = await axiosInstance({
      method: 'GET',
      url: '/seja-um-profissional/api/store/store-config',
    });

    return res.data;
  },
};
